// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-contenedor {
  padding: 1rem;
  background: #f9f9f9;
  border-radius: 0.5rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 1rem;
}

/*ESTILOS GENERALES DEL DASHBOARD (Migrados de cssAsociarPedCtnModal)*/
.dashboard-contenedor-flex {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 1.5rem; /* Separación entre Titulo y Columna de Datos */
  align-items: center;
  width: 100%;
  margin: 0;
  padding: 0;
}

/* Bloque Título (Izquierda) */
.dashboard-title {
  flex: 0 0 auto; /* ancho automático según contenido */
  margin: 0;
  padding: 0;
}
.dashboard-title h4 {
  margin: 0;
  padding: 0;
}

/* Bloque Columna de Datos (Derecha) */
.dashboard-data-column {
  display: flex;
  flex-direction: column;
  gap: 0.5rem; /* Espacio entre fila superior e inferior */
  flex: 1 1;
}

/* Filas internas de datos */
.dashboard-stats-row,
.dashboard-tipos-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem; /* Espacio entre items (CBM, Peso, etc) */
  margin: 0;
  padding: 0;
}

.stat-item,
.tipo-item {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  white-space: nowrap;
}

.dashboard-preview-value {
  color: #666;
  font-size: 0.9em;
  font-style: italic;
  margin-left: 0.3rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/DashboardContenedor.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,WAAW,EAAE,+CAA+C;EAC5D,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA,8BAA8B;AAC9B;EACE,cAAc,EAAE,qCAAqC;EACrD,SAAS;EACT,UAAU;AACZ;AACA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAE,2CAA2C;EACxD,SAAO;AACT;;AAEA,4BAA4B;AAC5B;;EAEE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS,EAAE,yCAAyC;EACpD,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":[".dashboard-contenedor {\n  padding: 1rem;\n  background: #f9f9f9;\n  border-radius: 0.5rem;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  margin-bottom: 1rem;\n}\n\n/*ESTILOS GENERALES DEL DASHBOARD (Migrados de cssAsociarPedCtnModal)*/\n.dashboard-contenedor-flex {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  gap: 1.5rem; /* Separación entre Titulo y Columna de Datos */\n  align-items: center;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n/* Bloque Título (Izquierda) */\n.dashboard-title {\n  flex: 0 0 auto; /* ancho automático según contenido */\n  margin: 0;\n  padding: 0;\n}\n.dashboard-title h4 {\n  margin: 0;\n  padding: 0;\n}\n\n/* Bloque Columna de Datos (Derecha) */\n.dashboard-data-column {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem; /* Espacio entre fila superior e inferior */\n  flex: 1;\n}\n\n/* Filas internas de datos */\n.dashboard-stats-row,\n.dashboard-tipos-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 1rem; /* Espacio entre items (CBM, Peso, etc) */\n  margin: 0;\n  padding: 0;\n}\n\n.stat-item,\n.tipo-item {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  white-space: nowrap;\n}\n\n.dashboard-preview-value {\n  color: #666;\n  font-size: 0.9em;\n  font-style: italic;\n  margin-left: 0.3rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
